// vendors
import styled, { css } from 'styled-components';
import { lighten } from 'polished';

import theme from '../../styles/theme';
import IconArrow from '../../images/IconArrow';
import { speed } from '../../styles/animation';
import { greaterThan } from '../../utils/mediaQuery';
import responsiveStyle from '../../utils/responsiveStyle';

export const ChevronDown = styled(IconArrow)`
  position: absolute;
  right: 24px;

  width: 10px;
  margin-left: 10px;

  transform: rotate(90deg);

  cursor: pointer;

  pointer-events: none;

  > * {
    stroke: ${theme.colors.mineShaft500};
  }
`;

export const Wrapper = styled.div`
  position: relative;

  display: inline-flex;
  align-items: center;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  z-index: -1;

  width: 100%;
  height: 100%;

  background-color: ${theme.colors.primary};

  transition: background-color ${speed.superfast};

  will-change: background-color;

  @media screen and (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: ${theme.spaces.s0}rem ${theme.spaces.sm4}rem ${theme.spaces.s0}rem
    ${theme.spaces.s0}rem;

  ${greaterThan(theme.breakpoints.fonts[0])} {
    padding: ${theme.spaces.s0}rem ${theme.spaces.sm4}rem ${theme.spaces.s0}rem
      ${theme.spaces.sm1}rem;
  }

  ${greaterThan(theme.breakpoints.fonts[1])} {
    padding: ${theme.spaces.s0}rem ${theme.spaces.sm5}rem ${theme.spaces.s0}rem
      ${theme.spaces.sm2}rem;
  }

  color: ${theme.fontColors.body};
  font-weight: ${theme.fontWeights.body};
  line-height: ${theme.button.lineHeights[0]};
  ${responsiveStyle(
    'fontSize',
    theme.textInput.fontSizes,
    theme.breakpoints.fonts
  )};

  border: 0;

  outline: 2px solid transparent;
  outline-offset: 3px;

  cursor: pointer;

  appearance: none;

  :not([multiple]):not([size]) {
    background-image: none;
  }

  :focus {
    ${(props) =>
      !props.error &&
      css`
        outline: 2px solid ${theme.colors.wildSand800};
      `}

    & ~ ${Background} {
      background-color: ${theme.colors.azure100};
    }
  }

  :disabled {
    color: ${theme.colors.brownGrey700};

    cursor: no-drop;

    ${(props) =>
      props.error &&
      css`
        outline: 2px solid ${lighten(0.16, theme.colors.error)};
      `}

    & ~ ${ChevronDown} > * {
      stroke: ${theme.colors.brownGrey700};
    }

    & ~ ${Background} {
      background-color: ${theme.colors.disabled};
    }
  }

  ${(props) =>
    props.error &&
    css`
      outline: 2px solid ${theme.colors.error};
    `}
`;

export default StyledSelect;
